//you should replace this values with yours

export const environment = {
  production: false,
  forgeAPI: "oDa1gKU3FUdTi7zjmiMhfykDt3B8BZzo",
  cloudinary: {
    cloud_name: 'tribalchatapp',
    upload_preset: 'au4yreq9',
    // private_cdn: 'true',
    // api_key: '738911989332597',
    // api_secret: 'iJvbGQJGbkvckGIwJJGHZKlfi4c'
  },
  firebase: {
    apiKey: "AIzaSyD5Nm3MIBBOzr65wXgH1f1W5IJJmTdfAuY",
    authDomain: "tribalchatapp-5aec7.firebaseapp.com",
    databaseURL: "https://tribalchatapp-5aec7.firebaseio.com",
    projectId: "tribalchatapp-5aec7",
    storageBucket: "tribalchatapp-5aec7.firebasestorage.app",
    messagingSenderId: "603279990588",
    appId: "1:603279990588:web:7a7bdbee22a0900764c839",
    measurementId: "G-FFLEW9X62M"
  },
  gMaps: {
    apiKey: "AIzaSyCjQF7rhX95Kz-4AUiDV-8yCQiAL41sP5Q",
    markerSrc: "./assets/images/pin.min.png",
    yellowMarker: "./assets/images/maps/pin.yellow.png",
    redMarker: "./assets/images/maps/pin.red.png"
  },
  recaptchav3: {
    siteKey: "6LcxTHkUAAAAAKpouOiq8T2Mfd-cGNrfqPLKyzF4",
    secretKey: "6LcxTHkUAAAAADs0WNkf5bxDDqhPZ1Lka3t3hDv0"
  },
  stripe: {
    publishable_key: "pk_test_ZAkbEV1mXlHsOhWeCcV2RSxj"
  },
  africasTalking: {
    apiKey: "6467c7a3db75985b196d78c7f585deb37e9242eefb19373a6a4c7f6441b56cc7",
    username: "sandbox"
  },
  google_web_client_id: "709430970251-j98kjjr8b94bmjs1e965b201datfgq2l.apps.googleusercontent.com",
  //facebook_app_id: 826720427470540,
  wordpress_url: 'http://wordpress.startapplabs.com/blog/',
  wordpress_rest_api_url: 'http://wordpress.startapplabs.com/blog/wp-json/wp/v2/',
  backendURL: 'http://localhost:5001/tribalchatapp-5aec7/us-central1',
  // backendURL: 'https://us-central1-tribalchatapp-5aec7.cloudfunctions.net',
  defaultImages: {
    notAvailable: "./assets/images/no_image_available.jpg"
  },
  youtube: {
    liveNews: "https://www.youtube.com/embed/Y5P9eFU6gQw"
  },
  qrCodeUrl: "https://www.appsapk.com/qr-code-scanner/",
  sendGridApi: "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"
};


// WEBPACK FOOTER //
// ./src/environment/environment.ts